import { useEffect, Suspense } from 'react';
import { Route, useNavigate, useLocation, Routes } from 'react-router';

import CharityVettingAcceptsAllFoodAndNonFoodEntry from '../../../common-flow/entries/CharityVettingAcceptsAllFoodAndNonFoodEntry';
import CharityVettingAcceptsAllFoodsEntry from '../../../common-flow/entries/CharityVettingAcceptsAllFoodsEntry';
import CharityVettingAcceptsAllNonFoodEntry from '../../../common-flow/entries/CharityVettingAcceptsAllNonFoodEntry';
import CharityVettingContactDetailsEntry from '../../../common-flow/entries/CharityVettingContactDetailsEntry';
import CharityVettingDonationPreferencesEntry from '../../../common-flow/entries/CharityVettingDonationPreferencesEntry';
import CharityVettingGetStartedEntry from '../../../common-flow/entries/CharityVettingGetStartedEntry';
import CharityVettingLegalRepresentativeEntry from '../../../common-flow/entries/CharityVettingLegalRepresentativeEntry';
import CharityVettingManualContactDetailsEntry from '../../../common-flow/entries/CharityVettingManualContactDetailsEntry';
import CharityVettingReviewDetailsEntry from '../../../common-flow/entries/CharityVettingReviewDetailsEntry';
import CharityVettingSearchDetailsEntry from '../../../common-flow/entries/CharityVettingSearchDetailsEntry';
import CharityVettingSocialAccountsEntry from '../../../common-flow/entries/CharityVettingSocialAccountsEntry';
import CharityVettingUnwantedFoodEntry from '../../../common-flow/entries/CharityVettingUnwantedFoodEntry';
import { vettingPath } from '../../../common-flow/entries/path';

import CharityVettingCharityNumberRoute from './CharityVettingCharityNumberRoute';
import CharityVettingCompanyNumberRoute from './CharityVettingCompanyNumberRoute';
import CharityVettingCompanyRegistrationRoute from './CharityVettingCompanyRegistrationRoute';
import CharityVettingFoodHygieneRoute from './CharityVettingFoodHygieneRoute';
import CharityVettingOrganisationTypeRoute from './CharityVettingOrganisationTypeRoute';
import CharityVettingPliRoute from './CharityVettingPliRoute';
import CharityVettingSubmitFoodHygieneCertificateRoute from './CharityVettingSubmitFoodHygieneCertificateRoute';
import FoodHygieneCertificateRoute from './FoodHygieneCertificateRoute';
import PliCoverRoute from './PliCoverRoute';

const CharityVettingRoutesUK = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === vettingPath.basePath) {
      navigate(vettingPath.getStartedPath, { replace: true });
    }
  }, []); // eslint-disable-line  react-hooks/exhaustive-deps

  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path={vettingPath.getStartedPath} element={<CharityVettingGetStartedEntry />} />
        <Route path={vettingPath.searchPath} element={<CharityVettingSearchDetailsEntry />} />
        <Route
          path={vettingPath.contactDetailsPath}
          element={<CharityVettingContactDetailsEntry />}
        />
        <Route
          path={vettingPath.manualContactDetailsPath}
          element={<CharityVettingManualContactDetailsEntry />}
        />
        <Route
          path={vettingPath.legalRepresentativePath}
          element={<CharityVettingLegalRepresentativeEntry />}
        />
        <Route
          path={vettingPath.registrationPath}
          element={<CharityVettingOrganisationTypeRoute />}
        />
        <Route
          path={vettingPath.charityNumberPath}
          element={<CharityVettingCharityNumberRoute />}
        />
        <Route
          path={vettingPath.companyRegistrationPath}
          element={<CharityVettingCompanyRegistrationRoute />}
        />
        <Route
          path={vettingPath.companyNumberPath}
          element={<CharityVettingCompanyNumberRoute />}
        />
        <Route path={vettingPath.pliPath} element={<CharityVettingPliRoute />} />
        <Route path={vettingPath.pliCoverPath} element={<PliCoverRoute />} />

        <Route
          path={vettingPath.donationPreferencesPath}
          element={<CharityVettingDonationPreferencesEntry />}
        />
        <Route
          path={vettingPath.acceptAllFoodsPath}
          element={<CharityVettingAcceptsAllFoodsEntry />}
        />
        <Route
          path={vettingPath.acceptAllNonFoodPath}
          element={<CharityVettingAcceptsAllNonFoodEntry />}
        />
        <Route
          path={vettingPath.acceptAllFoodAndNonFoodPath}
          element={<CharityVettingAcceptsAllFoodAndNonFoodEntry />}
        />
        <Route path={vettingPath.unwantedFoodPath} element={<CharityVettingUnwantedFoodEntry />} />
        <Route path={vettingPath.foodHygienePath} element={<CharityVettingFoodHygieneRoute />} />
        <Route
          path={vettingPath.foodHygieneCertificatePath}
          element={<FoodHygieneCertificateRoute />}
        />
        <Route
          path={vettingPath.SubmitFoodHygieneCertificatePath}
          element={<CharityVettingSubmitFoodHygieneCertificateRoute />}
        />
        <Route
          path={vettingPath.socialAccountsPath}
          element={<CharityVettingSocialAccountsEntry />}
        />
        <Route
          path={vettingPath.reviewDetailsPath}
          element={<CharityVettingReviewDetailsEntry />}
        />
      </Routes>
    </Suspense>
  );
};

export default CharityVettingRoutesUK;
